import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AppProvider, Page, Frame, Toast, Card, Button } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/es.json';
import OrderSupplyFilterForm from '@presentational/order_supply/OrderSupplyFilterForm';
import OrderSupplyRequestModal from '@presentational/order_supply/OrderSupplyRequestModal';
import OrderSupplyConfirmationModal from '@presentational/order_supply/OrderSupplyConfirmationModal';

import flatten from 'lodash/flatten';
import uniq from 'lodash/uniq';

import { Map } from 'immutable';

import axiosRails from '@utils/axios';

const propTypes = {
  queryURL: PropTypes.string.isRequired,
  querySellerURL: PropTypes.string.isRequired,
  defaultExcludedLocationId: PropTypes.string,
};


class OrderSupplyFormContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterOptions: {
        fulfillment: "unfulfilled",
        financial: "",
        order_status: "open",
        order_tags: ["En Proceso de Compra"],
        excluded_location_id: props.defaultExcludedLocationId || "",

        toastMessage: "",

        ship_hero_filtering: true,
        ship_hero_status: "En Proceso de Compra"
      },

      loading: false,
      isRequest: false,
      modalActive: false,
      itemsByVendor: null,
      selectedVendorKey: "",

      displayConfirmation: false,
    }
  }

  render() {
    const { toastMessage, displayConfirmation } = this.state;
    // console.log("State", this.state);
    return (
      <AppProvider i18n={translations}>
        <Frame>
          <Page
            fullWidth
            title={ I18n.t("app.new_order_supply") }
            breadcrumbs={[{content: I18n.t("actions.back"), url: '/order_supplies'}]}
          >
            <OrderSupplyFilterForm
              values={ this.state.filterOptions }
              loading={ this.state.loading }
              handleChange={ this.handleChange }
              locations={ this.props.locations }
              onTagsChange={this.onTagsChange}
              handleSubmit={ this.buildReport }
            />
            <OrderSupplyRequestModal
              open={ this.state.modalActive }
              onClose={ this.closeModal }
              items={ this.state.itemsByVendor }
              onRequest={ this.onRequest }
              loading={ this.state.loading }
            />

            <OrderSupplyConfirmationModal
              open={displayConfirmation}
              onCancel={ () => this.setState({ displayConfirmation: false, selectedVendorKey: "" }) }
              onAction={ this.submitRequest }
              loading={ this.state.loading }
            />

            { !!toastMessage ?
              <Toast
                content={toastMessage}
                onDismiss={ () => this.setState({toastMessage: ""}) } />
              : null
            }
          </Page>
        </Frame>
      </AppProvider>
    );
  }

  buildReport = async () => {
    // Query orders and display them to create OrderSupplies by vendor
    const { filterOptions } = this.state;
    await this.setState({ loading: true });
    try {
      let response = await axiosRails.post(this.props.queryURL, {
        filterOptions,
      });
      console.log("RES", response)
      if(response.data.success){
        this.setState({
          itemsByVendor: Map(response.data.orders), // TODO Rename response.data.orders to itemsByVendor
          modalActive: true,
        })
      }

    } catch (error) {
      await this.setState({
        toastMessage: "Ocurrio un error al intentar generar el reporte.",
      })
    }
    await this.setState({ loading: false });
  }

  closeModal = () => {
    this.setState({
      modalActive: false
    })
  }

  onTagsChange = (tags) => {
    this.handleChange(tags, "order_tags");
  }

  handleChange = (value, name) => {
    this.setState( (state) => ({
      filterOptions: {
        ...state.filterOptions,
        [name]: value,
      }
    }))
  }

  onRequest = async (vendorKey) => {
    await this.setState({
      selectedVendorKey: vendorKey,
    });
    // Query if vendor exists in app
    let response = await axiosRails.get(this.props.querySellerURL, {
      params: { vendor: vendorKey }
    });
    if(response.data.exists){
      await this.submitRequest();
    }
    else{
      await this.setState({
        displayConfirmation: true
      })
    }
  }

  submitRequest = async() => {
    if (this.state.loading) return false;
    const { submitURL } = this.props;
    const { itemsByVendor, selectedVendorKey } = this.state;
    const currentGroup = itemsByVendor.get(selectedVendorKey); // Object/Hash with lineitems info, identified by vendor name key.

    const updatedItemsByVendor = itemsByVendor.set(selectedVendorKey, {
      ...currentGroup,
      requested: true
    });

    // let lineItemsIds = currentGroup.lineItems.map( li => li.combinedIds ); // Combined ids is an array with the line items ids(unique), useful when two orders has same product(but diff li i)
    let lineItemsIds = [];
    let orderIds = []

    // Actually currentGroup.lineItems should be named .products since each item represent a product with the associated line_items_ids linked to that PRODUCT.
    for( let li of currentGroup.lineItems ){
      lineItemsIds = [...lineItemsIds, li.combinedIds];
      orderIds = [ ...orderIds, li.combinedOrderIds ];
    }

    lineItemsIds = flatten(lineItemsIds); // flatten the arrays (one array each line item/product/row)
    orderIds = flatten(orderIds);
    orderIds = uniq(orderIds); //

    // Optimistic update! View
    await this.setState({
      loading: true, displayConfirmation: false,
      itemsByVendor: updatedItemsByVendor
    });

    try {
      let response = await axiosRails.post(submitURL, {
        order_supply: {
          line_items_ids: lineItemsIds,
          order_ids: orderIds,
          vendor: selectedVendorKey,
          quantity: currentGroup.totalQuantity,
          items_data: currentGroup.shItemsData
        }
      });
      if(response.data.success){
        await this.setState({
          loading: false,
          toastMessage: I18n.t("app.messages.supply_requested"),
          selectedVendorKey: ""
        });
      }
      else{
        console.log("Failed order_supply creation", response.data);
        await this.setState({
          loading: false,
          itemsByVendor: itemsByVendor,
          toastMessage: I18n.t("app.messages.request_error"),
          selectedVendorKey: ""
        }) // Revert change
      }
    }
    // End try
    catch (error) {
      await this.setState({
        loading: false,
        itemsByVendor: itemsByVendor,
        toastMessage: I18n.t("app.messages.request_error"),
        selectedVendorKey: ""
      }) // Revert change
    }
  }

}

OrderSupplyFormContainer.propTypes = propTypes;


export default OrderSupplyFormContainer;
